import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dw-sidebar-entity__header" }
const _hoisted_2 = { class: "dw-sidebar-entity__badges" }
const _hoisted_3 = { class: "dw-sidebar-entity__title-container" }
const _hoisted_4 = { class: "dw-sidebar-entity__title" }
const _hoisted_5 = { class: "dw-sidebar-entity__content" }
const _hoisted_6 = { style: {"line-height":"1.2"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "content__divider" }, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "content__row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "Ответ КЦ", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.3335 8.66675L6.00016 11.3334L12.6668 4.66675",
    stroke: "#009DFF",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_badge = _resolveComponent("dw-badge")!
  const _component_dw_action_sequence_icon = _resolveComponent("dw-action-sequence-icon")!
  const _component_dw_checkbox = _resolveComponent("dw-checkbox")!
  const _component_dw_wait_list_status = _resolveComponent("dw-wait-list-status")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dw-sidebar-entity", { 'dw-sidebar-entity--done': _ctx.isEntityCompleted, 'dw-sidebar-entity--selected': _ctx.isEntitySelected }]),
    style: _normalizeStyle({ borderColor: _ctx.computedColor }),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (Boolean(_ctx.entity.waitListStatus))
          ? (_openBlock(), _createBlock(_component_dw_badge, {
              key: 0,
              class: "dw-badge--blue"
            }, {
              default: _withCtx(() => [
                _createTextVNode("ЛО")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.entity.delaying)
          ? (_openBlock(), _createBlock(_component_dw_badge, {
              key: 1,
              class: "dw-badge--red-light"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Опаздывающий")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.entity.downtimes.length)
          ? (_openBlock(), _createBlock(_component_dw_badge, {
              key: 2,
              class: "dw-badge--red-light"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Зафиксирован простой")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isCourierItem && _ctx.isEntityCompleted)
            ? (_openBlock(), _createBlock(_component_dw_action_sequence_icon, {
                key: 0,
                "action-sequence": _ctx.entity.actionSequence
              }, null, 8, ["action-sequence"]))
            : _createCommentVNode("", true),
          (_ctx.entity.type === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ((_ctx.entity as DispatcherWorkplaceTake).notAssigned)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Неназначенный забор")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Забор")
                    ], 64))
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.entity.type === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                ((_ctx.entity as DispatcherWorkplaceDelivery).notDelivered)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Невыданная доставка")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Доставка")
                    ], 64))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.selectable && (_ctx.entity.type === 1 && (_ctx.entity as DispatcherWorkplaceTake).notAssigned))
          ? (_openBlock(), _createBlock(_component_dw_checkbox, {
              key: 0,
              checked: _ctx.selectedUnassignedTakes.includes((_ctx.entity as DispatcherWorkplaceTake).orderId),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onToggleUnassignedTake((_ctx.entity as DispatcherWorkplaceTake).orderId)), ["stop"]))
            }, null, 8, ["checked"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        (_ctx.entity.type === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" №" + _toDisplayString((_ctx.entity as DispatcherWorkplaceTake).orderNumber), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.entity.type === 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" №" + _toDisplayString((_ctx.entity as DispatcherWorkplaceDelivery).invoiceNumber), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.entity.fullName), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.entity.fullAddress), 1),
      (_ctx.entity.type === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString((_ctx.entity as DispatcherWorkplaceTake).takeDate), 1))
        : _createCommentVNode("", true),
      (_ctx.entity.type === 1 && (_ctx.entity as DispatcherWorkplaceTake).takenAt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Забрано в: " + _toDisplayString((_ctx.entity as DispatcherWorkplaceTake).takenAt), 1))
        : _createCommentVNode("", true),
      (_ctx.entity.type === 2 && (_ctx.entity as DispatcherWorkplaceDelivery).deliveredAt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Доставлено в: " + _toDisplayString((_ctx.entity as DispatcherWorkplaceDelivery).deliveredAt), 1))
        : _createCommentVNode("", true),
      ((_ctx.entity.type === 1 && (_ctx.entity as DispatcherWorkplaceTake).notAssigned))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Сектор: " + _toDisplayString(_ctx.entity.sectorName || '-'), 1))
        : _createCommentVNode("", true),
      (Boolean(_ctx.entity.waitListStatus))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _hoisted_11,
            _createVNode(_component_dw_wait_list_status, {
              "wait-list-status": (_ctx.entity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus)
            }, null, 8, ["wait-list-status"]),
            _createElementVNode("div", null, "Инициатор: " + _toDisplayString((_ctx.entity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).user.name), 1),
            (Boolean((_ctx.entity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Дата изменения: " + _toDisplayString((_ctx.entity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              ((_ctx.entity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).source !== 'МПК')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 6))
}